import { useState, type CSSProperties } from "react";
import { avatarHue } from "../lib/avatar";
import { monogram } from "../lib/nav";

/**
 * ONE AVATAR (W81, pro web step 7) — a person's photo when there is one, else their initials on THEIR hue
 * (`avatarHue(name)`, pure). The colour itself is `pro.css`'s `.ht-avatar`; this component only hands it the hue as
 * `--avatar-h`, so no page paints a colour.
 *
 * ⚠️ DECORATIVE, as every monogram before it was (`aria-hidden`): the name is always written beside it, so a screen
 * reader hearing "YB, Yiannis Bravos" would hear the person twice.
 * ⚠️ A PHOTO THAT FAILS TO LOAD FALLS BACK TO THE INITIALS rather than drawing a broken image — a public-bucket URL can
 * outlive its object.
 */
export function Avatar({ name, photoUrl = null, className = "" }: { name: string; photoUrl?: string | null; className?: string }) {
  const [broken, setBroken] = useState(false);
  const style = { "--avatar-h": String(avatarHue(name)) } as CSSProperties;
  const photo = photoUrl !== null && photoUrl !== "" && !broken;
  return (
    <span className={`ht-avatar${photo ? " has-photo" : ""}${className === "" ? "" : ` ${className}`}`} style={style} aria-hidden="true">
      {photo ? <img src={photoUrl} alt="" loading="lazy" decoding="async" onError={() => setBroken(true)} /> : monogram(name)}
    </span>
  );
}
